import React from 'react';
import { Link } from 'react-router-dom'

const Menu = () => {
  return (
    <nav className='default-nav'>
      <ul>
        <li><Link to="/"><i className="fas fa-home" /></Link></li>
        <li><Link to="/Administration"><i className="fas fa-user-lock" /></Link></li>
      </ul>
    </nav>
  )
}

export default Menu




// WEBPACK FOOTER //
// ./src/components/menu.js